<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />
    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />

      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <!-- BEGIN: Subheader -->
        <div class="m-subheader">
          <div class="d-flex align-items-center">
            <div class="mr-auto">
              <h3
                v-if="admin"
                class="m-subheader__title"
              >
                {{ admin.Name }}
              </h3>
              <h3
                v-else
                class="m-subheader__title"
              >
                {{ $t('Dashboard.Dashboard') }}
              </h3>
            </div>
          </div>
        </div>
        <!-- END: Subheader -->

        <div class="m-content">
          <LoginAs :ref="'loginAs'" />
        </div>
      </div>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AdminFooter />
    <!-- END: Footer -->
  </div>
</template>

<script>
import AppHeader from '../admin/common/Header.vue';
import AdminFooter from '../admin/common/Footer.vue';
import LeftMenu from  '../admin/common/menus/LeftMenu.vue';
import LoginAs from '../admin/LoginAs.vue';
import { getAdmin } from '../../../functions.ts';

export default {
    components: {
        AdminFooter,
        AppHeader,
        LeftMenu,
        LoginAs,
    },
    data() {
        return {
            admin: {},
        };
    },
    mounted() {
        this.admin = getAdmin();

        if ( this.admin === null ) {
            this.$router.replace( '/' );
            return;
        }
    },
};
</script>
